import { Fragment } from 'react';
import Button from '../common/Button.component';
import { IconButton, Tooltip } from '@mui/material';
import ContentCopyIcon from '@mui/icons-material/ContentCopy';

const DuplicateButton = ({
  isIcon = false,
  success = false,
  onClick = () => {},
  disabled=false
}) => {
  return (
    <Fragment>
      {isIcon ? (
        <Tooltip title='Duplicate'>
          <IconButton
            onClick={onClick}
            disabled={disabled||success}
            size='small'
            color='primary'
          >
            <ContentCopyIcon />
          </IconButton>
        </Tooltip>
      ) : (
        <Button
          variant='outlined'
          startIcon={<ContentCopyIcon />}
          onClick={onClick}
          disabled={disabled||success}
        >
          Duplicate
        </Button>
      )}
    </Fragment>
  );
};

export default DuplicateButton;
